import { useMemo, useState } from "react";
import Categories from "../Processes/conversations/utils/categories.json";
import { getSasToken } from "~/utils/fileUtils";
import { useSelector } from "react-redux";

const useAddAttachments = (files, setFiles, type, regData) => {
  const [showUploadModal, setShowUploadModal] = useState(false);
  const { role } = useSelector((state) => state.login);

  const fileSupported = [
    "xls",
    "csv",
    "xml",
    "pdf",
    "jpg",
    "jpeg",
    "png",
    "txt",
    "doc",
    "docx",
    "xlsx",
  ];

  const uploadFileHandler = (file) => {
    setFiles((prevFiles) => [...prevFiles, ...file]);
  };

  const getType = () => {
    const name = regData.preferred_name
      ? `${regData.preferred_name}`
      : `${regData?.name}${regData?.last_name ? " " + regData?.last_name : ""}`;
    return { name };
  };

  const getCategoryAndSubcategoryNames = (categoryCode, subCategoryCode) => {
    const category = Categories.find((cat) => cat.code === categoryCode);
    const subCategory = category?.subCategory?.find(
      (sub) => sub.code === subCategoryCode,
    );

    return {
      categoryName: category?.name || categoryCode,
      subCategoryName: subCategory?.name || subCategoryCode,
    };
  };

  const downloadFileHandler = async (file) => {
    try {
      const sasToken = await getSasToken("documents");
      const baseUrl = file.objectURL.split("?")[0];
      const downloadUrl = `${baseUrl}?${sasToken}`;
      const response = await fetch(downloadUrl);
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = file.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const handleDelete = (rowData) => {
    const updatedFiles = files.filter(
      (obj) => JSON.stringify(obj) !== JSON.stringify(rowData),
    );
    setFiles(updatedFiles);
  };

  const officerAttachmentConfig = useMemo(() => {
    if (type === "officer") {
      return {
        attachmentDescription:
          "Upload and categorize supporting documents for this officer.",
        noDocUploadedDescription:
          "Upload supporting documents for this officer, such as ID or proof of address.",
      };
    } else if (type === "power-of-attorney") {
      return {
        attachmentDescription:
          "Upload and categorize supporting documents for this Attorney.",
        noDocUploadedDescription:
          "Upload supporting documents for this attorney, such as ID or proof of address.",
      };
    }
  }, [type]);

  return {
    showUploadModal,
    setShowUploadModal,
    fileSupported,
    uploadFileHandler,
    getType,
    getCategoryAndSubcategoryNames,
    downloadFileHandler,
    handleDelete,
    officerAttachmentConfig,
    role,
  };
};

export default useAddAttachments;
